<template>
	<div>Forced Language Not Found</div>
</template>

<script>
export default {
	name: 'forced-language-not-found'
}
</script>